import {
  ApplicationName as MDUMActivityTrackingApplicationName,
  ApplicationNameForMobilityServices,
} from '@telstra-connect/mobile-data-usage-meter/activity-tracking'
import type {IMobilityAppState} from '@telstra-connect/mobile-data-usage-meter/state'
import {getMDUMFlags} from '@telstra-connect/mobile-data-usage-meter/feature-flags'
import {getDashboardFlags} from '@telstra-connect/dashboard/feature-flags/load-flags'
import {isFlagOn} from '@telstra-connect/feature-flags'
import type {IApplicationDefinition, IAppRegistry} from '@apps-config/app-definition'
import {RoutesHelper} from '@apps-config/routing/routing'
import {Activity} from '@utils/activity-tracking'
import {isObject} from '@utils/isObject'
import {secureRouteBuilder} from '../secure-route'
import Routes from './route-constants'
import OfferDetailsPage from './pages/view-offer-details/index-lazy'
import {platformAppName, requestManagement} from '@telstra-connect/utils/data/platform-data'
import MobilityServiceContainer from './cards/mobility-service/index-lazy'
import {getRedesignTilesPhase2} from '@applications'
import {NotAuthorisedError, NotFoundError} from './components/error-page'
import ServiceDetailsPage from './pages/strategic-details-tabs/index-lazy'
import LegacyDetailsTabPage from './pages/view-unified-legacy-details-tab-page/index-lazy'
import {RedirectToMobility} from './utils/helper'
import LandingPage from './pages/landing-page/index-lazy'
import {MpexDynamic5gCustomer} from './pages/mpex-dynamic-customer/index-lazy'

const routes = new RoutesHelper({
  rootPath: secureRouteBuilder(`${Routes.MobileDataUsage}/${Routes.viewPlans}`),
  subpagesPathMask: secureRouteBuilder(Routes.MobileDataUsage),
})

export const mobileDataUsageMeterRoute = routes.getAppPath()

const applicationName = MDUMActivityTrackingApplicationName
const tracker = Activity.createTracker(applicationName)
const trackerForMobilityServices = Activity.createTracker(ApplicationNameForMobilityServices)
// FIXME: added below line by discussing with Somesh as no clear understanding with SRM_APPNAME and IM_APPNAME.
const MDUM_APPNAME = MDUMActivityTrackingApplicationName
// FIXME: need to check and get understanding from Somesh.
// const IM_APPNAME = IMActivity.ApplicationName;
// const SRM_APPNAME = SRMActivity.ApplicationName;

export function isMDUMAvailable() {
  // FIXME: window['applications'] is used as global object need to pass this a param
  // pass this a to MFE's and other subapplications platform
  // eslint-disable-next-line dot-notation,@typescript-eslint/dot-notation
  // eslint-disable-next-line dot-notation,@typescript-eslint/dot-notation
  const servicesConfig = window['applications']
  if (servicesConfig == null) {
    return false
  }
  if (isObject(servicesConfig[applicationName]) && servicesConfig[applicationName].mdum) {
    return true
  }
  return false
}

export function isRequestManagementAvailable() {
  // eslint-disable-next-line dot-notation,@typescript-eslint/dot-notation
  const servicesConfig = window['applications']
  if (servicesConfig == null) {
    return false
  }
  if (servicesConfig?.[requestManagement]) {
    return true
  }
  return false
}

export function shouldEnableSubmitBugLink() {
  // FIXME: window['applications'] is used as global object need to pass this a param
  // pass this a to MFE's and other subapplications platform
  // eslint-disable-next-line dot-notation,@typescript-eslint/dot-notation
  const servicesConfig = window['applications']
  if (servicesConfig == null) {
    return false
  }
  // FIXME: added below line by discussing with Somesh as no clear understanding with SRM_APPNAME and IM_APPNAME.
  if (isObject(servicesConfig[applicationName]) && isObject(servicesConfig[MDUM_APPNAME])) {
    return true
  }

  return false
}
export function getRedesignDataRichTileFlag() {
  // FIXME: window['applications'] is used as global object need to pass this a param
  // pass this a to MFE's and other subapplications platform

  // eslint-disable-next-line dot-notation,@typescript-eslint/dot-notation
  const servicesConfig = window['applications']
  if (servicesConfig == null) {
    return false
  }
  if (
    isObject(servicesConfig[platformAppName]) &&
    servicesConfig[platformAppName].redesignDataRichTiles
  ) {
    return true
  }
  return false
}
export function getlegacyMAC() {
  // FIXME: window['applications'] is used as global object need to pass this a param
  // pass this a to MFE's and other subapplications platform

  // eslint-disable-next-line dot-notation,@typescript-eslint/dot-notation
  const servicesConfig = window['applications']
  if (servicesConfig == null) {
    return false
  }
  if (servicesConfig?.[requestManagement]?.customProperties?.legacyMAC) {
    return true
  }
  return false
}

export function getReadOnlyUser() {
  // eslint-disable-next-line dot-notation,@typescript-eslint/dot-notation
  const servicesConfig = window['applications']
  if (servicesConfig == null) {
    return false
  }
  if (servicesConfig?.[requestManagement]?.customProperties?.roles === 'READ_ONLY') {
    return true
  }
  return false
}

export function getlegacyMACType2() {
  // FIXME: window['applications'] is used as global object need to pass this a param
  // pass this a to MFE's and other subapplications platform

  // eslint-disable-next-line dot-notation,@typescript-eslint/dot-notation
  const servicesConfig = window['applications']
  if (servicesConfig == null) {
    return false
  }
  if (servicesConfig?.[requestManagement]?.customProperties?.legacyMAC === 'type2') {
    return true
  }
  return false
}

export const Application: IApplicationDefinition = {
  get applicationName() {
    return applicationName
  },

  get acceptsUserFeedback() {
    return true
  },

  get acceptsErrorReports() {
    return true
  },

  get card() {
    const isMDUMAvailableFlag = isMDUMAvailable()
    // check for new flag
    const isNewFlagOn = getRedesignTilesPhase2()
    if (isMDUMAvailableFlag) {
      if (isNewFlagOn) return MobilityServiceContainer
    }
  },

  get tracker() {
    return tracker
  },

  get trackerForMobilityServices() {
    return trackerForMobilityServices
  },

  get routes() {
    return routes
  },

  init(registry: IAppRegistry, availableToUser: boolean) {
    const flags = getMDUMFlags()
    const isMDUMEnabledFlag = isMDUMAvailable()
    if (isFlagOn(flags.application)) {
      if (availableToUser && isMDUMEnabledFlag) {
        registry.add(Application)
      }
    }
  },

  render() {
    return [
      {
        path: routes.getPageSubpath(Routes.viewPlans),
        component: LandingPage,
      },
      {
        path: routes.getPageSubpath(Routes.OfferDetailsStrategic),
        component: OfferDetailsPage,
      },
      {
        path: routes.getPageSubpath(Routes.OfferDetailsLegacy),
        component: OfferDetailsPage,
      },
      {
        path: routes.getPageSubpath(Routes.StrategicServiceDetails),
        component: ServiceDetailsPage,
      },
      {
        path: routes.getPageSubpath(Routes.StrategicServiceDetailsWithoutCidn),
        component: ServiceDetailsPage,
      },
      {
        path: routes.getPageSubpath(Routes.LegacyServiceDetails),
        component: LegacyDetailsTabPage,
      },
      {
        path: routes.getPageSubpath(Routes.mobileServicesDetailStrategic),
        component: ServiceDetailsPage,
      },
      {
        path: routes.getPageSubpath(Routes.mobileServicesDetailLegacy),
        component: LegacyDetailsTabPage,
      },
      {
        path: routes.getPageSubpath(Routes.MpexDynamic5g),
        component: MpexDynamic5gCustomer,
      },
      {
        path: routes.getPageSubpath(Routes.MpexDynamic5gStrategicDetails),
        component: MpexDynamic5gCustomer,
      },
      {
        path: routes.getPageSubpath(Routes.viewMobileServices),
        component: LandingPage,
      },
      {
        path: Routes.MobileDataUsageMeter,
        component: RedirectToMobility,
      },
      {
        path: routes.getPageSubpath(Routes.NotFound),
        component: NotFoundError,
      },
      {
        path: routes.getPageSubpath(Routes.NotAuthorised),
        component: NotAuthorisedError,
      },
    ]
  },

  menuItem(state, navigate) {
    const SiteMenuFeatureFlag = isFlagOn(getDashboardFlags().sideMenu)

    return SiteMenuFeatureFlag
      ? [
          {
            testID: 'ui-menu-mobile-data-usage-meter',
            name: 'Monitoring and performance',
            intialPagePath: routes.getInitialPagePath(),
            appPath: routes.getAppPath(),
            notificationsCount: 0,
            onClick: () => {
              Application.tracker.trackMenu('Monitoring and performance')
              return navigate(routes.getInitialPagePath())
            },
          },
        ]
      : [
          {
            testID: 'ui-menu-mobile-data-usage-meter',
            name: 'Monitoring and performance',
            intialPagePath: routes.getInitialPagePath(),
            appPath: routes.getAppPath(),
            notificationsCount: 0,
            onClick: () => {
              Application.tracker.trackMenu('Monitoring and performance')
            },
          },
        ]
  },
}

export {IMobilityAppState, Routes}
